'use strict';

exports.__esModule = true;
exports.widgetActions = exports.GET_SPECIALIST_PEER_RECOMMENDATIONS_FOR_PRACTICE = exports.GET_SPECIALISTS_PEER_RECOMMENDATIONS_COUNT = exports.GET_SPECIALIST_REVIEWS_FOR_PRACTICE = exports.GET_SPECIALISTS_PEER_RECOMMENDATIONS = exports.GET_SPECIALIST_PEER_RECOMMENDATIONS = exports.GET_SPECIALISTS_REVIEWS_COUNT = exports.GET_SPECIALISTS_REVIEWS = exports.GET_SPECIALIST_REVIEWS = exports.DISABLE_PROFILE_IMAGE = exports.GET_PRACTICE_REVIEWS = exports.SET_PROFILE_TYPE = exports.SET_MIN_REVIEW_RATING = exports.SET_LAYOUT_TYPE = exports.LOAD_SPECIALIST = exports.DISABLE_BANNER = exports.LOAD_PRACTICE = exports.DISABLE_TABS = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _doctifyUtils = require('doctify-utils');

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var DISABLE_TABS = exports.DISABLE_TABS = 'WIDGET_ACTIONS:DISABLE_TABS';
var LOAD_PRACTICE = exports.LOAD_PRACTICE = 'WIDGET_ACTIONS:LOAD_PRACTICE';
var DISABLE_BANNER = exports.DISABLE_BANNER = 'WIDGET_ACTIONS:DISABLE_BANNER';
var LOAD_SPECIALIST = exports.LOAD_SPECIALIST = 'WIDGET_ACTIONS:LOAD_SPECIALIST';
var SET_LAYOUT_TYPE = exports.SET_LAYOUT_TYPE = 'WIDGET_ACTIONS:SET_LAYOUT_TYPE';
var SET_MIN_REVIEW_RATING = exports.SET_MIN_REVIEW_RATING = 'WIDGET_ACTIONS:SET_MIN_REVIEW_RATING';
var SET_PROFILE_TYPE = exports.SET_PROFILE_TYPE = 'WIDGET_ACTIONS:SET_PROFILE_TYPE';
var GET_PRACTICE_REVIEWS = exports.GET_PRACTICE_REVIEWS = 'WIDGET_ACTIONS:GET_PRACTICE_REVIEWS';
var DISABLE_PROFILE_IMAGE = exports.DISABLE_PROFILE_IMAGE = 'WIDGET_ACTIONS:DISABLE_PROFILE_IMAGE';
var GET_SPECIALIST_REVIEWS = exports.GET_SPECIALIST_REVIEWS = 'WIDGET_ACTIONS:GET_SPECIALIST_REVIEWS';
var GET_SPECIALISTS_REVIEWS = exports.GET_SPECIALISTS_REVIEWS = 'WIDGET_ACTIONS:GET_SPECIALISTS_REVIEWS';
var GET_SPECIALISTS_REVIEWS_COUNT = exports.GET_SPECIALISTS_REVIEWS_COUNT = 'WIDGET_ACTIONS:GET_SPECIALISTS_REVIEWS_COUNT';
var GET_SPECIALIST_PEER_RECOMMENDATIONS = exports.GET_SPECIALIST_PEER_RECOMMENDATIONS = 'WIDGET_ACTIONS:GET_SPECIALIST_PEER_RECOMMENDATIONS';
var GET_SPECIALISTS_PEER_RECOMMENDATIONS = exports.GET_SPECIALISTS_PEER_RECOMMENDATIONS = 'WIDGET_ACTIONS:GET_SPECIALISTS_PEER_RECOMMENDATIONS';
var GET_SPECIALIST_REVIEWS_FOR_PRACTICE = exports.GET_SPECIALIST_REVIEWS_FOR_PRACTICE = 'WIDGET_ACTIONS:GET_SPECIALIST_REVIEWS_FOR_PRACTICE';
var GET_SPECIALISTS_PEER_RECOMMENDATIONS_COUNT = exports.GET_SPECIALISTS_PEER_RECOMMENDATIONS_COUNT = 'WIDGET_ACTIONS:GET_SPECIALISTS_PEER_RECOMMENDATIONS_COUNT';
var GET_SPECIALIST_PEER_RECOMMENDATIONS_FOR_PRACTICE = exports.GET_SPECIALIST_PEER_RECOMMENDATIONS_FOR_PRACTICE = 'WIDGET_ACTIONS:GET_SPECIALIST_PEER_RECOMMENDATIONS_FOR_PRACTICE';

var widgetActions = {
	loadPractice: function loadPractice(id, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			actionType: LOAD_PRACTICE,
			method: 'GET',
			url: 'practices/' + id,
			xhrConfig: xhrConfig
		});
	},
	loadSpecialist: function loadSpecialist(id, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			actionType: LOAD_SPECIALIST,
			method: 'GET',
			url: 'specialists/' + id,
			xhrConfig: xhrConfig
		});
	},
	getReviews: function getReviews(id, parameters, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			method: 'GET',
			url: 'practices/' + id + '/reviews',
			actionType: GET_PRACTICE_REVIEWS,
			parameters: (0, _extends3.default)({}, parameters, {
				status_filter: 'approved',
				verified_filter: true
			}),
			xhrConfig: xhrConfig
		});
	},
	getSpecialistReviews: function getSpecialistReviews(id, type, parameters, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			method: 'GET',
			url: 'specialists/' + id + '/reviews',
			actionType: _constants.SPECIALIST_PROFILE_TYPE === type ? GET_SPECIALIST_REVIEWS : GET_SPECIALIST_REVIEWS_FOR_PRACTICE,
			parameters: (0, _extends3.default)({}, parameters, {
				status_filter: 'approved',
				verified_filter: true
			}),
			xhrConfig: xhrConfig
		});
	},
	getSpecialistPeerRecommendations: function getSpecialistPeerRecommendations(id, type, parameters, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			method: 'GET',
			url: 'specialists/' + id + '/peer_recommendations',
			actionType: _constants.SPECIALIST_PROFILE_TYPE === type ? GET_SPECIALIST_PEER_RECOMMENDATIONS : GET_SPECIALIST_PEER_RECOMMENDATIONS_FOR_PRACTICE,
			parameters: (0, _extends3.default)({}, parameters, {
				status_filter: 'approved'
			}),
			xhrConfig: xhrConfig
		});
	},
	getSpecialistsReviewsCount: function getSpecialistsReviewsCount(id, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			method: 'GET',
			url: 'practices/' + id + '/specialists/reviews/count',
			actionType: GET_SPECIALISTS_REVIEWS_COUNT,
			xhrConfig: xhrConfig
		});
	},
	getSpecialistsPeerRecommendationsCount: function getSpecialistsPeerRecommendationsCount(id, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			method: 'GET',
			url: 'practices/' + id + '/specialists/peer_recommendations/count',
			actionType: GET_SPECIALISTS_PEER_RECOMMENDATIONS_COUNT,
			xhrConfig: xhrConfig
		});
	},
	getSpecialistsReviews: function getSpecialistsReviews(id, parameters, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			method: 'GET',
			url: 'practices/' + id + '/specialists/reviews',
			actionType: GET_SPECIALISTS_REVIEWS,
			parameters: (0, _extends3.default)({}, parameters, {
				status_filter: 'approved',
				verified_filter: true
			}),
			xhrConfig: xhrConfig
		});
	},
	getSpecialistsPeerRecommendations: function getSpecialistsPeerRecommendations(id, parameters, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			method: 'GET',
			url: 'practices/' + id + '/specialists/peer_recommendations',
			actionType: GET_SPECIALISTS_PEER_RECOMMENDATIONS,
			parameters: (0, _extends3.default)({}, parameters, {
				status_filter: 'approved'
			}),
			xhrConfig: xhrConfig
		});
	},
	setLayoutType: function setLayoutType(layoutType) {
		return {
			type: SET_LAYOUT_TYPE,
			layoutType: layoutType
		};
	},
	setProfileType: function setProfileType(profileType) {
		return {
			type: SET_PROFILE_TYPE,
			profileType: profileType
		};
	},
	disableBanner: function disableBanner(_disableBanner) {
		return {
			type: DISABLE_BANNER,
			disableBanner: _disableBanner
		};
	},
	disableProfileImage: function disableProfileImage(_disableProfileImage) {
		return {
			type: DISABLE_PROFILE_IMAGE,
			disableProfileImage: _disableProfileImage
		};
	},
	disableTabs: function disableTabs(_disableTabs) {
		return {
			type: DISABLE_TABS,
			disableTabs: _disableTabs
		};
	},
	setMinReviewRating: function setMinReviewRating(minReviewRating) {
		return {
			type: SET_MIN_REVIEW_RATING,
			minReviewRating: minReviewRating
		};
	}
};
exports.widgetActions = widgetActions;